import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }

import { computed, onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import { consoleGet } from "@/common/api/rest/console/console";

import type { ConsoleType } from "@/common/types/console/console";

import TabConsoleInfos from "@/components/tabs/console/infos.vue";
import TabConsoleDetails from "@/components/tabs/console/details.vue";
import TabConsoleGames from "@/components/tabs/console/games.vue";
import TabConsoleImages from "@/components/tabs/console/images.vue";
import TabConsoleSlug from "@/components/tabs/console/slug.vue";
import TabConsoleName from "@/components/tabs/console/name.vue";
import TabConsoleAccessory from "@/components/tabs/console/accessory.vue";

import { breadcrumbSimple, iconMenu, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: '[tab]',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const selectedTab = ref("infos");
const consoleData = ref<ConsoleType | null>(null);

const consoleId = computed(() => route.params.item as string);

const breadcrumbList = computed(() => [
  {
    key: "collections",
    label: t("common.labels.collections"),
    url: `/collection`,
  },
  {
    key: "collection",
    label: t("collection.labels.consoles"),
    url: `/collection/console`,
  },
  {
    key: "edit",
    label: consoleData.value?.name ?? "...",
  },
]);

const menuList = computed(() => [
  {
    key: "infos",
    icon: "field",
    label: t("collection.labels.infos"),
    url: `/collection/console/${consoleId.value}/infos`,
  },
  {
    key: "name",
    icon: "no-image",
    label: t("common.labels.other_names"),
    url: `/collection/console/${consoleId.value}/name`,
  },
  {
    key: "slug",
    icon: "no-image",
    label: t("slug.labels.slugs"),
    url: `/collection/console/${consoleId.value}/slug`,
  },
  {
    key: "image",
    icon: "no-image",
    label: t("collection.labels.images"),
    url: `/collection/console/${consoleId.value}/image`,
  },
  {
    key: "details",
    icon: "no-image",
    label: t("collection.labels.details"),
    url: `/collection/console/${consoleId.value}/details`,
  },
  {
    key: "game",
    icon: "game",
    label: t("collection.labels.games"),
    url: `/collection/console/${consoleId.value}/game`,
  },
  {
    key: "accessory",
    icon: "gamepad",
    label: t("collection.labels.accessories"),
    url: `/collection/console/${consoleId.value}/accessory`,
  },
]);

function back() {
  router.push(`/collection/console`);
}

async function changeMenu(url: string) {
  await fetchData();
  router.push(url);
}

// console
async function fetchData() {
  await consoleGet(consoleId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        consoleData.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

watch(
  () => route.params.tab,
  () => {
    selectedTab.value = route.params.tab as string;
  },
  {
    immediate: true,
  },
);

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "gamepad",
            size: "2rem"
          }),
          _cache[3] || (_cache[3] = _createTextVNode(" EDITAR CONSOLE ", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default w-8 h-8",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(iconMenu), {
          tabs: menuList.value,
          active: selectedTab.value,
          size: "3rem",
          onSelected: _cache[1] || (_cache[1] = ($event: any) => (changeMenu($event)))
        }, null, 8, ["tabs", "active"]),
        (consoleData.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (selectedTab.value === 'infos')
                ? (_openBlock(), _createBlock(TabConsoleInfos, {
                    key: 0,
                    "console-id": consoleId.value,
                    console: consoleData.value,
                    "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => (fetchData()))
                  }, null, 8, ["console-id", "console"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'image')
                ? (_openBlock(), _createBlock(TabConsoleImages, {
                    key: 1,
                    "console-id": consoleId.value
                  }, null, 8, ["console-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'game')
                ? (_openBlock(), _createBlock(TabConsoleGames, {
                    key: 2,
                    "console-id": consoleId.value
                  }, null, 8, ["console-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'accessory')
                ? (_openBlock(), _createBlock(TabConsoleAccessory, {
                    key: 3,
                    "console-id": consoleId.value
                  }, null, 8, ["console-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'slug')
                ? (_openBlock(), _createBlock(TabConsoleSlug, {
                    key: 4,
                    "console-id": consoleId.value
                  }, null, 8, ["console-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'name')
                ? (_openBlock(), _createBlock(TabConsoleName, {
                    key: 5,
                    "console-id": consoleId.value
                  }, null, 8, ["console-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'details')
                ? (_openBlock(), _createBlock(TabConsoleDetails, {
                    key: 6,
                    "console-id": consoleId.value
                  }, null, 8, ["console-id"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})